import React, { useState } from "react"
import { IInnRegistryDto } from "../../../types/inn/IInnRegistryDto"
import { ModalConfirm } from "../../common/element/ModalConfirm"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { IModalMessage } from "../../../types/error/IModalMessage"
import Button from "@/ui/components/Button"

import style from "./style.module.scss"
import { BanksTable } from "./Banks"

export const CurrencyPayerPopUpListItem: React.FC<{
  inn: IInnRegistryDto
  remove: (id: number) => void
  refetch: () => void
}> = ({ inn, remove, refetch }) => {
  const [modalConfirm, setModalConfirm] = useState<IModalMessage>()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [showBanks, setShowBanks] = useState(false)

  const confirmRemove = (val: any) => {
    if (val) {
      remove(val)
    }
  }

  const getHumanStatus = (status: string | undefined) => {
    switch (status) {
      case "BLOCKED":
        return "Заблокирована"
      case "APPROVED":
        return "Одобрена"
      case "PENDING":
        return "На проверке"
      default:
        return "На проверке"
    }
  }

  return (
    <div>
      <ModalConfirm message={modalConfirm} setMessage={setModalConfirm} />
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <li className="currency_inn_item">
        {inn.status === "BLOCKED" ? (
          <p
            onClick={() =>
              setModalMessage({
                ...modalMessage,
                title: "Инфо",
                text: `Компания заблокирована по причине: ${inn.reason}`
              })
            }
          >
            {inn.name}
          </p>
        ) : (
          <p>{inn.name}</p>
        )}
        <p>{inn.address || "-"}</p>
        <p>{getHumanStatus(inn.status)}</p>
        <div className="flex-row-10">
          <Button variant="black" onClick={() => setShowBanks(!showBanks)}>
            Банки
          </Button>
          <div>
            <button
              className="delete_item"
              onClick={() =>
                setModalConfirm({
                  title: "Удалить валютного плательщика?",
                  text: `Вы действительно желаете удалить валютного плательщика (${inn.name})?`,
                  callbackValue: inn.id,
                  _callback: confirmRemove
                })
              }
            />
          </div>
        </div>
      </li>
      {showBanks && (
        <div className={style.banks}>
          <BanksTable title={inn.name || ""} banks={inn.banksRef || []} payerId={String(inn.id)} refetch={refetch} />
        </div>
      )}
    </div>
  )
}
